import { Component, Input, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_SCHEDULER_IMPORTS } from "@app/scheduler/common-scheduler-imports"
import { SchedulerComponent } from "@app/scheduler/scheduler.component"

@Component({
	selector: "app-test-scheduler",
	imports: [COMMON_SCHEDULER_IMPORTS],
	changeDetection: ChangeDetectionStrategy.Eager,
	templateUrl: "../scheduler/scheduler.component.html",
})
export class TestSchedulerComponent extends SchedulerComponent {
	@Input() test_id: number

	async handleContactwaysClose(arr: any) {
		const contactway_id = arr[0].id
		const daysArr = this.data.daysArr.map((it) => Number(it.num))
		const sendObj = {
			...this.data,
			daysArr,
			test_id: this.test_id,
			patient_id: this.patient_id,
			contactway_id,
		}
		this.isSaving = true
		const res: any = await this.apiService.post("create_testschedule", sendObj)
		this.isSaving = false
		if (res?.id) {
			this.store.addGenItemRow("testschedules", res)
		}
		this.modalService.openToast(
			res?.id ? "created_successfully" : "save_failed"
		)
		this.onClose.emit()
	}
	async handleSubmit() {
		this.isModalOpen = true
	}
}
